import { createUserManager } from 'redux-oidc';
import { OidcConfig } from '../config';
import { isSchool } from './helperFunctions';

let config = isSchool() ? OidcConfig.school : OidcConfig.private;

export const userManager = createUserManager(config);
